import { Block } from '@/components/base/Block'
import { Checkbox } from '@/components/base/Form/Checkbox'
import { CheckboxSize } from '@/components/base/Form/Checkbox/Checkbox'
import { Icon } from '@/components/base/Icon'
import { Text5, Text3, Text4 } from '@/components/base/Text'
import { useApp } from '@/hooks/useApp'
import { commonBorder } from '@/styles/border'
import borderRadius from '@/styles/border_radius'
import { cursor } from '@/styles/cursor'
import { display, align } from '@/styles/display'
import { fontSize } from '@/styles/font'
import spaceStyle from '@/styles/space'
import textAlign from '@/styles/text_align'
import { isEmpty } from 'lodash'
import {
  V1IconType,
  V1JobOfferAcceptanceStatusType,
  type V1JobOfferAcceptanceAttachmentFile
} from 'mnvm-mypage-app-ts-if'
import { downloadFileFromBase64 } from '../../common'

interface Props {
  checked: boolean
  onChecked: () => void
  isCheckboxDisable: boolean
  files?: V1JobOfferAcceptanceAttachmentFile[]
  status: V1JobOfferAcceptanceStatusType
}
export const OfferAcceptanceFileSection = ({
  checked,
  onChecked,
  isCheckboxDisable,
  files,
  status
}: Props): JSX.Element => {
  const app = useApp()

  return (
    <Block
      display={display.FLEX}
      alignItems={align.FLEX_START}
      textAlign={align.LEFT}
      backgroundColor={app.theme.lightGrayColor}
      borderRadius={{ all: borderRadius.L }}
      margin={{ vertical: spaceStyle.M }}
      padding={{
        all: spaceStyle.M
      }}
      style={{ boxSizing: 'border-box', flexDirection: 'column', gap: 8 }}
    >
      <Text5
        textColor={app.theme.mainTextColor}
        margin={{ horizontal: spaceStyle.NONE }}
        maxLines={1}
      >
        {'ファイル名をクリックしてダウンロードください'}
      </Text5>
      {files?.map((item) => (
        <OfferAcceptanceFileItem
          key={item.id}
          id={item.id}
          name={item.name}
          file={item.file}
        ></OfferAcceptanceFileItem>
      ))}
      {status === V1JobOfferAcceptanceStatusType.Pending ? (
        <Block
          width={'100%'}
          display={display.FLEX}
          style={{ boxSizing: 'border-box', flexDirection: 'column', gap: 8 }}
        >
          <Block
            width={'100%'}
            display={display.FLEX}
            justifyContent={align.CENTER}
            alignItems={align.CENTER}
            textAlign={textAlign.LEFT}
            padding={{
              horizontal: spaceStyle.M,
              vertical: spaceStyle.S
            }}
            style={{
              boxSizing: 'border-box',
              flexDirection: 'row'
            }}
          >
            <Checkbox
              disabled={isCheckboxDisable}
              disableColor={app.theme.inactiveColor}
              size={CheckboxSize.Size16}
              onChange={onChecked}
              checked={checked}
            />
            <Text3
              textColor={
                isCheckboxDisable
                  ? app.theme.inactiveColor
                  : app.theme.mainTextColor
              }
              // fontWeight={fontWeight.Bold}
              margin={{ horizontal: spaceStyle.NONE }}
            >
              {'労働条件通知に関わる書面を確認しました'}
            </Text3>
          </Block>
          <Text5 margin={{ horizontal: spaceStyle.NONE }}>
            {'（全ての書類をダウンロード後、チェックしてください）'}
          </Text5>
        </Block>
      ) : (
        <></>
      )}
    </Block>
  )
}

interface OfferAcceptanceFileItemProps {
  id?: string
  name?: string
  file?: string
}

const OfferAcceptanceFileItem = ({
  id,
  name,
  file
}: OfferAcceptanceFileItemProps): JSX.Element => {
  const app = useApp()
  return (
    <Block width={'100%'}>
      <Block
        id={id}
        display={display.FLEX}
        alignItems={align.CENTER}
        border={{ ...commonBorder, color: app.theme.frameColor }}
        borderRadius={{ all: borderRadius.MAX }}
        margin={{ top: spaceStyle.XS }}
        padding={{
          horizontal: spaceStyle.M,
          vertical: spaceStyle.S
        }}
        style={{
          boxSizing: 'border-box',
          flexDirection: 'row'
        }}
        onClick={() => {
          if (file != null && !isEmpty(file))
            downloadFileFromBase64(file, name ?? '')
        }}
      >
        <Icon
          iconType={V1IconType.EditDocument}
          iconStyle={{
            fontSize: fontSize.S,
            theme: app.theme.primaryMainColor,
            cursor: cursor.POINTER
          }}
        />
        <Block textAlign={align.LEFT} style={{ flex: 1 }}>
          <Text4
            textColor={app.theme.primaryMainColor}
            margin={{ horizontal: spaceStyle.NONE }}
            maxLines={1}
            cursor={cursor.POINTER}
          >
            {name}
          </Text4>
        </Block>

        <Icon
          iconType={V1IconType.ArrowDownward}
          iconStyle={{
            fontSize: fontSize.M,
            theme: app.theme.mainTextColor,
            cursor: cursor.POINTER
          }}
        />
      </Block>
    </Block>
  )
}
